export const sendWarrantySMS = async (warrantyData) => {
  try {
    const {
      consumerName,
      warrantyId,
      mobileNumber,
      warrantyStartDate,
      warrantyEndDate
    } = warrantyData;

    // We now send the request to our secure Vercel Backend instead of MSG91 directly to avoid CORS
    const response = await fetch("/api/sendSms", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        mobileNumber,
        consumerName,
        warrantyId,
        warrantyStartDate,
        warrantyEndDate
      })
    });
    
    if (!response.ok) {
      throw new Error("Failed to send SMS via secure API");
    }

    // Logging for monitoring
    console.log(`[SMS Sent] To ${mobileNumber}: Warranty ID ${warrantyId} created for ${consumerName}. Valid from ${warrantyStartDate} to ${warrantyEndDate}.`);
    
    return {
      success: true,
      message: "SMS sent successfully"
    };
  } catch (error) {
    console.error("SMS sending failed:", error);
    return {
      success: false,
      error: error.message
    };
  }
};
